// frontend/src/components/CategorySection.js

import React from 'react';
import './CategorySection.css';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { Link } from 'react-router-dom';
// New import path: Use the centralized categories data from the correct folder
import categories from './categories';

const CategorySection = () => {
    // For the categories grid fade-in/slide-up animation
    const [gridRef, isGridVisible] = useScrollAnimation(0.1);

    return (
        <section id="categories-section" className="category-section">
            <h2 className="sectionnn-title">Explore Our Spice Collections</h2>

            <div className={`category-items-grid ${isGridVisible ? 'show' : ''}`} ref={gridRef}>
                {categories.map(category => {
                    return (
                        <Link
                            // Use backendValue for the route to match backend expectations
                            to={`/products/${encodeURIComponent(category.backendValue)}`}
                            key={category.id}
                            className="category-card"
                        >
                            {/* NEW: Wrapper div to handle relative positioning for the badge */}
                            <div className="category-image-container">
                                
                                {/* --- NEW: Picture element for responsive images --- */}
                                <picture className="category-picture-wrapper">
                                    {/* If category has a mobileImage, show it on screens smaller than 768px */}
                                    {category.mobileImage && (
                                        <source media="(max-width: 768px)" srcSet={category.mobileImage} />
                                    )}
                                    {/* Fallback/Desktop image */}
                                    <img
                                        src={category.image}
                                        alt={category.name} 
                                        className="category-image"
                                    />
                                </picture>

                                {/* CONDITIONAL BADGE: Only show if isComingSoon is true */}
                                {category.isComingSoon && (
                                    <div className="subtle-coming-soon-badge">Coming Soon</div>
                                )}
                            </div>

                            <h3 className="category-name">{category.name}</h3> {/* Display name on the card */}
                        </Link>
                    );
                })}
            </div>
        </section>
    );
};

export default CategorySection;